import { render, staticRenderFns } from "./ClaimBankDetails.vue?vue&type=template&id=67b3f70d&"
import script from "./ClaimBankDetails.vue?vue&type=script&lang=js&"
export * from "./ClaimBankDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports